import React from 'react';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import {green} from '@material-ui/core/colors';
import Fab from '@material-ui/core/Fab';
import CheckIcon from '@material-ui/icons/Check';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
    buttonSuccess: {
        border: "2px solid #fff",
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },

    fabProgress: {
        color: "#fff",
        position: 'absolute',
        top: -6,
        left: -6,
        zIndex: 1,
    },
    buttonProgress: {
        color: "#fff",
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}));

export default function CircularIntegration({load, done}) {
    const classes = useStyles();
    const [success, setSuccess] = React.useState(false);
    const timer = React.useRef();

    const buttonClassname = clsx({
        [classes.buttonSuccess]: success,
    });

    React.useEffect(() => {
        setSuccess(done);
        return () => {
            clearTimeout(timer.current);
        };
    }, [done]);


    return (
        <div className={classes.root}>
            <div className={classes.wrapper}>
                <Fab
                    aria-label="Save"
                    style={{
                        "color": "white",
                        backgroundColor: "#d02764",
                        boxShadow: "none !important",
                        border: "1px solid #fffff",
                    }}
                    className={buttonClassname}>
                    {success ? <CheckIcon/> : ""}
                </Fab>
                {load && <CircularProgress size={68} className={classes.fabProgress}/>}
            </div>
        </div>
    );
}
